import { SliceProps } from "@/Slice/index"
import { CTA } from "@/components"
import { Link, NextImage } from "@jog/react-components"
import { asLink, asText, isFilled } from "@prismicio/helpers"
import classNames from "classnames"

export const VideoBanner = ({
    slice: { primary, items },
    className,
    lcp,
}: SliceProps<"video_banner"> & { lcp: boolean }) => {
    const showVideo = isFilled.image(primary.image_desktop) && isFilled.richText(primary.embed_url)
    const showMobileVideo = isFilled.image(primary.image_mobile) && isFilled.richText(primary.embed_url_mobile)
    if (!showVideo && !showMobileVideo) return <></>
    const embedUrl = asText(primary.embed_url)
    const embedUrlMobile = asText(primary.embed_url_mobile)
    return (
        <div className={classNames("relative h-[100vw] w-full overflow-hidden md:h-full", className)}>
            <NextImage
                className="hidden md:inline md:h-auto md:w-full"
                src={primary.image_desktop.url || ""}
                height={primary?.image_desktop?.dimensions?.height}
                width={primary?.image_desktop?.dimensions?.width}
                sizes="100vw"
                alt={primary?.image_desktop?.alt || "video banner cover"}
                lcp={lcp}
            />
            <NextImage
                className="inline h-auto w-full md:hidden"
                src={primary?.image_mobile?.url || ""}
                sizes="100vw"
                height={primary?.image_mobile?.dimensions?.height}
                width={primary?.image_mobile?.dimensions?.width}
                alt={primary?.image_mobile?.alt || "video banner cover"}
                lcp={lcp}
            />
            <iframe
                className="absolute top-1/2 left-1/2 hidden h-full w-[178%] -translate-x-1/2 -translate-y-1/2 border-0 md:block md:h-[115%] md:w-full"
                src={embedUrl || ""}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="video banner"
            />
            <iframe
                className="absolute top-1/2 left-1/2 block h-full w-[178%] -translate-x-1/2 -translate-y-1/2 border-0 md:hidden md:h-[115%] md:w-full"
                src={embedUrlMobile || embedUrl || ""}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="video banner"
            />
            {isFilled.link(primary.video_banner_url) && (
                <Link
                    className="z-1 absolute top-0 left-0 h-full w-full cursor-pointer"
                    href={asLink(primary?.video_banner_url)}
                    aria-label="video banner link"
                />
            )}
            <div
                className="absolute z-[2] flex w-[70vw] -translate-x-1/2 -translate-y-1/2 flex-row flex-wrap items-center justify-center gap-2 md:flex-nowrap"
                style={{ top: `${primary.cta_top_position || 80}%`, left: `${primary.cta_left_position || 50}%` }}>
                {items
                    .filter((item) => isFilled.title(item.cta_label) && isFilled.link(item.cta_url))
                    .map((item, index) => (
                        <Link href={asLink(item.cta_url)} key={index} onClick={(e) => e.stopPropagation()}>
                            <CTA
                                color={primary.cta_text_color || ""}
                                bgColor={primary.cta_bg_color || ""}
                                colorHover={primary.cta_hover_text_color || ""}
                                bgColorHover={primary.cta_hover_bg_color || ""}
                                borderWidth={primary.cta_border_width || 0}
                                borderColor={primary.cta_border_color || ""}
                                fontSizeMobile={primary.cta_font_size_mobile || ""}>
                                {asText(item.cta_label)}
                            </CTA>
                        </Link>
                    ))}
            </div>
        </div>
    )
}
